import MenuButton from "../MenuButton";
import WorkflowStatus from '../../workflowStatus/WorkflowStatus'
import {selectStatusById} from '../../workflowStatus/selectors'
import {unsafe_selectWithState} from '../../redux/utils'

export default class TaskStatusButton extends MenuButton {
    constructor({
        editable = true,
        taskStatusMenu = null,
        showStatusTypePrefix = false,
        hideName = false,
        onStatusChangedCb = (id) => {},
        positionParams = {offset: "0px 1px"},
        onShowMenu = () => {},
        onHideMenu = () => {},
    }) {
        super({
            editable,
            positionParams,
            onShowMenu,
            onHideMenu,
        })
        this.taskStatusMenu = taskStatusMenu
        this.showStatusTypePrefix = showStatusTypePrefix
        this.hideName = hideName

        this.state = {
            statusId: -1,
            canReopenProject: false,
        }

        this.callbacks = {
            onStatusChangedCb,
        }

        this.onStatePropertyChanged('statusId', () => {
            if (this.rendered) {
                this._renderStatus()
            }
        })
    }

    templateHtml() {
        return "<div class='taskStatusButton'></div>"
    }

    afterRender() {
        super.afterRender();
    }

    _renderStatus() {
        this.getEl().empty()
        this.status = new WorkflowStatus({
            ...unsafe_selectWithState((state) => selectStatusById(state, this.state.statusId)),
            showTypePrefix: this.showStatusTypePrefix,
            showArrow: this.editable,
            hideName: this.hideName,
        }).init(this.getEl())
    }

    setEditable(editable) {
        this.editable = editable
        this._renderStatus()
        this.update()
    }

    getMenu() {
        this.taskStatusMenu.setStatusId(this.state.statusId)
        this.taskStatusMenu.setInactiveOpenStatuses(!this.state.canReopenProject)
        return this.taskStatusMenu;
    }

    _change(id) {
        if (id !== this.state.statusId) {
            this.callbacks.onStatusChangedCb(id)
            return true;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./web/js/controls/task/TaskStatusButton.js